import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft } from "lucide-react";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="bg-white">
      <Seo title="Sidan finns inte – Se Klart Ut" description="Sidan du letar efter finns inte." noindex />
      <section className="relative overflow-hidden">
        <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-brand-ice blur-3xl opacity-70" aria-hidden="true" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand-blue">404</p>
          <h1 className="mt-4 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight text-brand-ink">
            Här var det tomt – <span className="font-accent italic font-semibold text-brand-blue">men fönstren ser vi till att fylla.</span>
          </h1>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed max-w-xl mx-auto">
            Sidan du letar efter finns inte eller har flyttats. Ta dig tillbaka till startsidan – eller boka din kostnadsfria offert direkt.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" data-testid="notfound-home" className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-brand-ink border border-slate-200 font-semibold px-8 py-4 hover:border-brand-blue hover:text-brand-blue transition-all duration-300">
              <ArrowLeft className="h-4 w-4" /> Till startsidan
            </Link>
            <Link to="/boka-offert" data-testid="notfound-book" className="group inline-flex items-center justify-center gap-2 rounded-full bg-brand-blue text-white font-semibold px-8 py-4 hover:bg-brand-blueHover hover:-translate-y-0.5 hover:shadow-[0_14px_35px_rgba(14,98,254,0.35)] active:translate-y-0 transition-all duration-300">
              Boka fönsterputs <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
